import React, { useEffect, useRef, useState } from 'react';
import logo from '../assets/images/logo.png';
import './About.css';

const About = () => {
  const sectionRefs = useRef([]);
  const [visibleSections, setVisibleSections] = useState([]);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.getAttribute('data-index'));
            setVisibleSections((prev) =>
              prev.includes(idx) ? prev : [...prev, idx]
            );
          }
        });
      },
      { threshold: 0.18 }
    );
    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });
    return () => observer.disconnect();
  }, []);

  const sections = [
    {
      title: 'What We Do',
      content: (
        <div className="what-we-do-beautified">
          <ul className="what-we-do-list">
            <li><strong>Importers & Distributors</strong> of RISEONIC Compatible Printer Cartridges</li>
            <li><strong>Suppliers</strong> of Cartridge Components & Printer Parts through a dealer network</li>
            <li><strong>Nationwide Support</strong> (Pan India)</li>
            <li><strong>Managed Print Services (MPS)</strong> & Printer/Laptop Rentals</li>
            <li><strong>Barcode Solutions:</strong> Printers, Scanners, Labels & Stickers</li>
            <li><strong>IT Hardware Supplies:</strong> Monitors, Batteries, Adapters, RAM, SSDs, Power Stations, Stabilizers, Keyboards, Mice & more</li>
          </ul>
        </div>
      ),
    },
    {
      title: 'Our Company Strategy',
      content: (
        <div className="what-we-do-beautified">
          <ul className="what-we-do-list">
            <li><strong>Purpose:</strong> To be a Leader in IT Industry by providing Enhanced Services, Relationship and Profitability.</li>
            <li>Provide quality services that exceed customer expectations.</li>
            <li>Build long-term relationships with customers and clients through exceptional service, innovation, and advanced technology.</li>
            <li>Grow through creativity, inventions, and innovations.</li>
            <li>Integrate honesty, integrity, and business ethics into all aspects of business functioning.</li>
            <li>Build a strong reputation and become a key player in the IT industry.</li>
          </ul>
        </div>
      ),
    },
    {
      title: 'After Sales Service',
      content: (
        <div className="what-we-do-beautified">
          <ul className="what-we-do-list">
            <li><strong>Quick Response:</strong> Fast support after implementations via help-desk, online communication, and site visits for technical support.</li>
            <li><strong>On-Site Service:</strong> Customer requests for on-site service are usually addressed within 12 working hours. Help desk support is always prompt.</li>
            <li><strong>Technical Support:</strong> Available 9:30-6:30, and on certain projects, 24x7x365.</li>
            <li>Ensuring customer satisfaction is our top priority.</li>
          </ul>
        </div>
      ),
    },
    {
      title: 'RISEONIC Toner Quality Details',
      content: (
        <div className="what-we-do-beautified">
          <ul className="what-we-do-list">
            <li><strong>Excellent Performance:</strong> Strict quality checks and A Grade materials ensure reliable, consistent, eco-friendly, and smudge-free print outputs.</li>
            <li><strong>Advanced Quality Ink:</strong> Delivers dark, smudge-free graphics and text. Compatible for corporate, bank, school, hospital, and home use.</li>
            <li><strong>Easy to Install and Use:</strong> Each cartridge passes strict quality checks for durability and compatibility. Designed for fast output with A grade components.</li>
            <li>Superior quality for everyday printing needs—clear and crisp content every time.</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <div className="about-page">
      {/* Hero Section from Home Page */}
      <section className="hero-section">
        <div className="home-container">
          <div className="home-content">
            <div className="logo-section">
              <div className="logo">
                <img src={logo} alt="Image Technology Logo" className="logo-image" loading="lazy" />
              </div>
            </div>
            <div className="text-section">
              <h2>About Image Technology.</h2>
              <p>
                Since 2016, Image Technology has delivered trusted printing solutions across India. Founded by industry veteran Mr. Bharat A. Patel, we specialize in high-quality toner cartridges and imaging products—empowering businesses through our proudly introduced RISEONIC brand. With a focus on innovation, service, and sustainability, we bring your printing needs to life.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="about-content">
        {sections.map((section, idx) => (
          <div
            className={`about-section${visibleSections.includes(idx) ? ' visible' : ''}`}
            key={section.title}
            ref={el => (sectionRefs.current[idx] = el)}
            data-index={idx}
          >
            <div className="about-text">
              <h2>{section.title}</h2>
              {section.content}
            </div>
          </div>
        ))}
      </div>

      {/* FAQ Section as Cards */}
      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-card">
            <h4>What is a compatible cartridge?</h4>
            <p>A compatible cartridge is not produced by the OEM but meets the same standards for performance, print quality, and yield.</p>
          </div>
          <div className="faq-card">
            <h4>Will using compatible cartridges void my printer warranty?</h4>
            <p>No, you are allowed to use them and it will not void your warranty. This is protected by law in most regions.</p>
          </div>
          <div className="faq-card">
            <h4>Are compatible cartridges cost-effective?</h4>
            <p>Yes, compatible cartridges can save you 60-70% compared to OEM cartridges while providing similar quality.</p>
          </div>
          <div className="faq-card">
            <h4>What about the quality of compatible cartridges?</h4>
            <p>Modern compatible cartridges meet high standards and are often preferred by users for their print quality and value.</p>
          </div>
          <div className="faq-card">
            <h4>How do I get support for my product?</h4>
            <p>Contact our support team via the Contact page or WhatsApp for quick assistance with any product or service.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 